module.exports = __webpack_public_path__ + "static/gricd-mobile-21da7750a938a812f647eae0031a3818.png";